const camelSegmentToSnake = (segment: string): string =>
  segment
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
    .toLowerCase()

export const keyToSnakeCase = (key: string): string =>
  key.split('.').map(camelSegmentToSnake).join('.')

const isPlainRecord = (value: unknown): value is Record<string, unknown> => {
  if (value === null || typeof value !== 'object') {
    return false
  }
  if (Array.isArray(value)) {
    return false
  }
  const proto = Object.getPrototypeOf(value)
  return proto === null || proto === Object.prototype
}

export const deepKeysToSnakeCase = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map(deepKeysToSnakeCase)
  }
  if (isPlainRecord(value)) {
    return Object.fromEntries(
      Object.entries(value).map(([key, v]) => [keyToSnakeCase(key), deepKeysToSnakeCase(v)]),
    )
  }
  return value
}
